// Source confidence panel (approved HTML component: source-confidence).
import type { ReactNode } from 'react';

export interface SourceConfidenceProps {
  rows: Array<{ label: string; value: string; fresh: boolean; stale: boolean }>;
  onViewDetail?: () => void;
}

export function SourceConfidence({ rows, onViewDetail }: SourceConfidenceProps): ReactNode {
  return (
    <section className="exec-card" data-component="source-confidence">
      <div className="exec-head">
        <h2>Source confidence</h2>
        <small>Last confirmed snapshot</small>
      </div>
      <div className="exec-body source-list">
        {rows.map(row => (
          <div key={row.label}>
            <span>{row.label}</span>
            <strong className={row.stale ? 'stale' : row.fresh ? 'fresh' : ''}>
              {row.value}
            </strong>
          </div>
        ))}
      </div>
      <div className="exec-body" style={{ paddingTop: 0 }}>
        <p className="exec-note">
          Source status is shown with the selected period. Stale data remains visibly marked.
        </p>
        <button
          id="view-sources"
          type="button"
          className="exec-text-button source-action"
          onClick={onViewDetail}
        >
          View source details →
        </button>
      </div>
    </section>
  );
}
